import Store from 'store/store'

/**
 * This is an important part of how the seeded procgen works.
 * We want to store all the informations related to the Landscape in one seed,
 * so that reverting to a specific Landscape is easily done.
 *
 * A Landscape is defined by three main components:
 * - The main abstraction, generated from a seed
 * - The colors, generated from a seed
 * - The background, defined by an index of the colors
 *
 * Each of this component may be needed at a certain point in the App to be
 * re-generated without impacting the other components, so we cannot rely on a
 * global seed.
 *
 * The seed, created from a Date.now() timestamp, is therefore splited in
 * several parts, each describing a specific component of the procgen:
 *
 *  1599667840580
 *  .             > describe a 1-based index for the background
 *   ............ > used as a seed for the landscape abstraction
 *     .......... > used ad a seed for the prng of the colors picking
 *
 * This way, it is possible :
 * - to iterate through landscapes without changing the colors scheme by
 *   incrementing the seed based on 1e10 step
 * - to change background color without impacting neither the colors or the
 *   landscape abstraction
 *
 * Note that as the colors seed is included in the abstraction seed, it is not
 * possible to change only the colors without impacting the abstraction. This is
 * by design for now, but may be easily changed in the future by removing the
 * colors part when using Seed.abstraction
 */

export default {
  update () {
    this.value = Date.now()
  },

  get value () { return Store.landscape.seed.get() },
  get background () { return (+this.value.toString()[0]) - 1 },
  get abstraction () { return +this.value.toString().substring(1) },
  get swatch () { return +this.value.toString().substring(3) },

  set value (seed) {
    Store.landscape.seed.set(+seed)
  },

  setBackground (index) {
    // We make index one-based instead of zero-based so that leading zero won't
    // be stripped when converting the seed value to Number
    index = index + 1
    this.value = parseInt(index + '' + this.abstraction)
  },

  incrementAbstraction () {
    this.value += 1e10
  }
}



// WEBPACK FOOTER //
// ./src/controllers/landscape/seed.js